module.exports = __webpack_public_path__ + "static/img/k_1@2x (1).6e966d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/k_1@2x (1).png
// module id = 3m86
// module chunks = 2